/**
 * @generated SignedSource<<1d10b839a7882bbf5a17c53137823257>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type UpdateExchangeRateInput = {
  id?: string | null;
  rate?: number | null;
  csrfToken?: string | null;
  socketClientId?: string | null;
  clientMutationId?: string | null;
};
export type updateExchangeRateMutation$variables = {
  input: UpdateExchangeRateInput;
};
export type updateExchangeRateMutation$data = {
  readonly updateExchangeRate: {
    readonly exchangeRate: {
      readonly rate: number | null;
    } | null;
  } | null;
};
export type updateExchangeRateMutation = {
  variables: updateExchangeRateMutation$variables;
  response: updateExchangeRateMutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "rate",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "updateExchangeRateMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "UpdateExchangeRatePayload",
        "kind": "LinkedField",
        "name": "updateExchangeRate",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "ExchangeRate",
            "kind": "LinkedField",
            "name": "exchangeRate",
            "plural": false,
            "selections": [
              (v2/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "updateExchangeRateMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "UpdateExchangeRatePayload",
        "kind": "LinkedField",
        "name": "updateExchangeRate",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "ExchangeRate",
            "kind": "LinkedField",
            "name": "exchangeRate",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "35c56b6a0c3147fc04d5ba67ae81999e",
    "id": null,
    "metadata": {},
    "name": "updateExchangeRateMutation",
    "operationKind": "mutation",
    "text": "mutation updateExchangeRateMutation(\n  $input: UpdateExchangeRateInput!\n) {\n  updateExchangeRate(input: $input) {\n    exchangeRate {\n      rate\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "db8e592a5c59871a06c0068479b150c2";

export default node;
